import { Component, Vue } from 'vue-property-decorator'
import { queryEndClass } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'class-over-list', components: { HighFilter } })
export default class ClassOverList extends Vue {
  private tableData = []
  private totalPage = 1;
  private totalNum = 1;
  private currentPage = 1;
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading = false
  created () {
    this.initPageData()
  }

  get Abnormalstudents () {
    return this.getAbnormalstudents()
  }

  getAbnormalstudents () {
    return this.tableData.filter((item: any) => { return item.status === 3 })
  }

  /**
   * [async description] 初始化页面数据
   */
  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryEndClass(param)
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.classList
    this.filterData = result.search
    this.tableloading = false
  }

  /**
   * [description] 分页切换回调函数
   */
  private async onPageChange () {
    this.initPageData()
  }

  statusFilter (status: any) {
    const statusStr = ['', '未上课', '上课中', '异常中', '已经结课']
    return statusStr[status]
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  rowClicked (row: any) {
    // detailType==1,班级列表类型详情｜｜其他默认值为‘’
    this.$router.push({ path: '/student/class_detail', query: { id: row.classId } })
  }

  goAbnormalStudents () {
    this.$router.push({ path: '/student/class_abnormal_students' })
  }
}
